import { render, staticRenderFns } from "./MrdInfo.vue?vue&type=template&id=e6edae64&scoped=true"
import script from "./MrdInfo.vue?vue&type=script&lang=js"
export * from "./MrdInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6edae64",
  null
  
)

export default component.exports